function setElement(element, value) {
  const htmlEl = element[0];

  if (!htmlEl) return;

  const tagName = htmlEl.tagName;

  switch (tagName) {
    case 'META':
      element.attr('content', value);
      break;
    case 'TITLE':
      element.text(value);
      break;
    case 'LINK':
      element.attr('href', value);
      break;
    default:
      element.attr('content', value);
      break;
  }
}

function Directive(metaTagService) {
  return {
    restrict: 'EA',
    link(scope, element, attrs) {
      const metaKey = attrs.metaKey;
      const metaTemplate = attrs.metaTemplate;

      if (!metaKey) return; //skip any meta tag elements that don't have the meta-key attribute

      const value = metaTagService.getKey(metaKey);

      if (value) {
        setElement(element, value);
      }

      metaTagService.subscribe('tagsChanged', scope, function() {
        let newValue = metaTagService.getKey(metaKey);

        if (metaTemplate) {
          newValue = metaTemplate.replace('@@', newValue);
        }

        setElement(element, newValue);
      });
    }
  };
}

Directive.$inject = [
  'metaTagService'
];

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/meta.js